// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"88":"1b2ebcdb5c0e752c","335":"03ecb5ea48e1309d","531":"d02643ba5bca9f31","822":"eab10b5f30f34dbb"}[chunkId] + ".js";
};